<template>
  <AppTableControl
    @query-debounced="searchByName"
    @search-clicked="$store.dispatch('getFacialDevices')"
    @reset-filters="resetFilters"
    @export-excel-clicked="
      $store.dispatch('fetchFacialDeviceReport', { type: 1 })
    "
    @export-pdf-clicked="
      $store.dispatch('fetchFacialDeviceReport', { type: 2 })
    "
  >
    <template #filters>
      <div class="d-flex">
        <!-- begin: Purchase Date     -->
        <b-form-group
          class="mr-4"
          label-class="text-bolder"
          label="Purchase Date"
        >
          <b-form-datepicker
            v-model="purchaseDate"
            id="from-date"
            class="form-control h-auto"
            @input="inputPurchaseDate"
          >
          </b-form-datepicker>
        </b-form-group>
        <!-- end: Purchase Date     -->
      </div>
    </template>
  </AppTableControl>
</template>

<script>
import AppTableControl from "@/modules/core/components/shared/table/AppTableControl";
import dayjs from "dayjs";

export default {
  name: "FacialDeviceTableControl",
  components: { AppTableControl },
  data() {
    return {
      purchaseDate: null,
    };
  },
  methods: {
    /**
     * Name query search.
     *
     * @param name
     */
    searchByName(name) {
      console.log(name);

      this.$store.dispatch("changeFDListNameFilter", { name: name });
      this.$store.dispatch("getFacialDevices");
    },

    /**
     * Reset the filters
     */
    resetFilters() {
      this.purchaseDate = null;

      this.inputPurchaseDate(null);
      this.$store.dispatch("getFacialDevices");
    },

    /**
     * Watch purchase date input
     *
     * @param date
     */
    inputPurchaseDate(date) {
      let formattedDate = date ? dayjs(date).format() : null;
      console.log(formattedDate);

      this.$store.dispatch("changeFDListPurchaseDateFilter", {
        date: formattedDate,
      });
    },
  },
};
</script>

<style scoped></style>
